<style lang="scss" scoped="">
  @import "../../assets/scss/mixins";

  .content-part {
    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  .batch-info {
    .oms-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right content-padding">
        <h3>订单明细</h3>
        <h2>订单信息</h2>
        <el-row style="margin-bottom:0">
          <oms-col :value="currentItem.orderNo" label="货主订单号"/>
          <oms-col :value="currentItem.upstreamOrgName" label="货主"/>
          <oms-col :value="currentItem.bizType" label="业务类型">
            <dict :dict-group="'bspBizType'" :dict-key="currentItem.bizType"></dict>
          </oms-col>
          <oms-col :value="currentItem.orderThirdNo" label="去向单位订单号"/>
          <oms-col :value="currentItem.downstreamOrgName" label="去向单位"/>
          <oms-col :value="currentItem.transportationMeans" label="物流方式">
            <dict :dict-group="'outTransportMeans'" :dict-key="currentItem.transportationMeans"></dict>
          </oms-col>
          <oms-col :value="currentItem.thirdLogisticsName" label="物流商"/>
          <template v-if="isInOrder">
            <oms-col :value="currentItem.upstreamOrgAddress" label="配送地址"/>
            <oms-col :value="currentItem.shippingAddress" label="提货地址"/>
            <oms-col :value="currentItem.consigneeName" label="申请人"/>
          </template>
          <template v-else>
            <oms-col :value="currentItem.shippingAddress" label="配送地址"/>
            <oms-col :value="currentItem.upstreamOrgAddress" label="货主仓库地址"/>
            <oms-col :value="currentItem.consigneeName" label="实际收货人"/>
            <oms-col :value="currentItem.consigneePhone" label="联系电话"/>
          </template>
          <oms-col :value="currentItem.transportationCondition" label="运输条件">
            <dict :dict-group="'transportationCondition'" :dict-key="currentItem.transportationCondition"></dict>
          </oms-col>
          <oms-col :value="currentItem.logisticsCentreName" label="物流中心"/>
          <oms-col :value="currentItem.createTime | minute" label="下单时间"/>
          <oms-col :label="`预计${isInOrder?'入': '出'}库时间`" :value="currentItem.estimatedExecutionTime | minute"/>
          <oms-col :value="currentItem.orderCompleteTime | minute" label="完成时间"/>
          <oms-col :is-show="true" :value="currentItem.qualifiedFlag" label="是否合格"
                   v-show="(typeof currentItem.qualifiedFlag === 'boolean') && currentItem.bizType === '1-1'">
            <span class="goods-span" v-show="currentItem.qualifiedFlag">合格</span>
            <span class="goods-span" v-show="!currentItem.qualifiedFlag">不合格</span>
          </oms-col>
          <oms-col :is-show="true" label="订单状态">{{ getOrderStatus(currentItem) }}</oms-col>

          <oms-col :value="currentItem.orderRemark" label="备注"/>
        </el-row>
        <h2>货品信息</h2>
        <el-row style="margin-bottom:0">
          <oms-col :value="currentItem.goodsName" label="货品"/>
          <oms-col :value="currentItem.orderAmount" label="数量"/>
          <oms-col :value="currentItem.specification" label="规格"/>
          <oms-col :value="currentItem.factoryName" label="生产厂商"></oms-col>
          <oms-col :value="currentItem.batchNumber" label="批号"></oms-col>
          <oms-col :value="currentItem.productionDate | date" label="生产日期"></oms-col>
          <oms-col :value="currentItem.expirationDate | date" label="有效期"></oms-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['currentItem', 'getOrderStatus'],
    data() {
      return {
        span: 9,
        list: [],
        loading: false
      };
    },
    computed: {
      isInOrder() {
        return this.currentItem.type === '0';
      }
    }
  };
</script>
